<script setup lang="ts">
import { useStore } from 'vuex'

const store = useStore()

const openPrivacyModal = () => {
  store.commit('SET_PRIVACY_MODAL_VISIBILITY', true)
}

const openTermsModal = () => {
  store.commit('SET_TERMS_MODAL_VISIBILITY', true)
}
</script>

<template>
  <section class="sa-acct-section sa-status-legal" aria-labelledby="status-legal-heading">
    <h2 id="status-legal-heading">{{ $t('Dashboard.Status.Legal.Heading') }}</h2>
    <p class="sa-status-section-lead">{{ $t('Dashboard.Status.Legal.Lead') }}</p>

    <div class="sa-status-action-list">
      <button type="button" class="sa-status-action" @click="openPrivacyModal">
        {{ $t('Dashboard.Status.Legal.Privacy') }}
        <svg class="sa-status-action__chev" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <button type="button" class="sa-status-action" @click="openTermsModal">
        {{ $t('Dashboard.Status.Legal.Terms') }}
        <svg class="sa-status-action__chev" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <p class="sa-status-legal__footnote">{{ $t('Dashboard.Status.Legal.Footnote') }}</p>
  </section>
</template>
